import { ref } from 'vue';
import type { userInterface } from '@/api/users';

// Module-level auth state to avoid circular dependencies.
// Stores the current user so axios.ts can distinguish "session expired" (401
// while authenticated) from "not logged in" (401 before any auth). Also tracks
// whether a logout navigation is in progress so the router guard does not
// immediately redirect back to the dashboard.

export const currentUser = ref<userInterface | null>(null);
export const isLoggingOut = ref(false);
export const appReady = ref(false);

export function setCurrentUser(user: userInterface | null): void {
    currentUser.value = user;
}

export function setLoggingOut(value: boolean): void {
    isLoggingOut.value = value;
}
